<template lang='pug'>
section
  v-toolbar(flat color='white')
    h2(class='title') Организации
    v-spacer
    v-btn(@click='organizationDialog = true' color='primary' depressed) Добавить
  v-divider
  v-data-table(
    :loading='isLoading'
    :headers='headers'
    :items='list'
    hide-actions
  )
    template(slot='items' slot-scope='props')
      tr(class='with-pointer' @click='onEdit(props.item.id)')
        td(data-label='#ID') {{ props.item.id }}
        td(data-label='Название') {{ props.item.organization_name }}
        td(data-label='Дата добавления') {{ props.item.created_at | date }}
        td(class='text-xs-right wrapless crud-tools')
          v-btn(icon @click.stop='removeOrganization(props.item.id)')
            v-icon(small) delete_outline
  s-link-organization(
    :dialog='organizationDialog'
    @select='onSelectOrganization'
    @close='organizationDialog = false'
  )
</template>

<script>
import http from '@/http'
export default {
  props: ['user'],

  data: () => ({
    list: [],
    isLoading: false,
    organizationDialog: false,
    headers: [
      { text: '#ID', align: 'left', width: '0%', sortable: false },
      { text: 'Название', align: 'left', width: '40%', sortable: false },
      { text: 'Дата добавления', align: 'left', width: '40%', sortable: false },
      { text: '', align: 'left', width: '0%', sortable: false }
    ]
  }),

  methods: {
    async fetchUserOrgs() {
      if (!this.user.id) return

      this.isLoading = true

      try {
        this.list = (await http.get(
          `admin/users/${this.user.id}/organizations`
        )).data
      } catch (e) {
        this.$showServerErrors(e)
      }

      this.isLoading = false
    },
    /*
    Удалить организацию у пользователя:
    DELETE /api/admin/users/{user_id}/organizations/{id}
    id - это связка пользователя и организации
     */
    async removeOrganization(id) {
      if (!this.isLoading && (await this.$confirm('Удалить организацию?'))) {
        this.isLoading = true

        try {
          await http.delete(`admin/users/${this.user.id}/organizations/${id}`)
          this.fetchUserOrgs()
        } catch (e) {
          this.$showServerErrors(e)
        }

        this.isLoading = false
      }
    },
    /*
    Добавить организацию пользователю:
    POST /api/admin/users/{user_id}/organizations
    organization_id - параметр обязательный
     */
    async addOrganization(id) {
      if (!this.isLoading) {
        this.isLoading = true

        try {
          await http.post(`admin/users/${this.user.id}/organizations`, {
            organization_id: id
          })
          this.fetchUserOrgs()
        } catch (e) {
          this.$showServerErrors(e)
        }

        this.isLoading = false
      }
    },

    onSelectOrganization({ id }) {
      this.organizationDialog = false
      this.addOrganization(id)
    }
  },

  watch: {
    user: {
      deep: true,
      handler() {
        this.fetchUserOrgs()
      }
    }
  }
}
</script>
